import { FC, useState, useRef, useEffect } from "react";
import Button from "../../components/UI/Button/Button";
import { transformGMTToUTC } from "../../Utility/Utility";
import StaticForm from "./staticImgUploaderForm";

import {
  StaticBannerSectionWrapper,
  DesktopBannerSection,
  BannerSectionTitle,
  AddImageBtn,
  BannerSectionSubtitle,
  StaticFormSection,
  Img,
  ActiveInactivewarpper,
} from "./StyledPromotions";

import { RootState } from "../../app/Store";
import {
  createPromotion,
  deletePromotionById,
  disableEnablePromotionById,
  setDesktopImgDetails,
  setMobileImgDetails,
  uploadPromotionImages,
} from "../../features/promotions";
import { useSelector, useDispatch } from "react-redux";
import { updatePromotion } from "../../features/promotions";

import TestStaticForm from "./TempStaticForm";
import { toggleNotificationVisibility } from "../../features/networkNotification";
import { NotificationType } from "../../Utility/InterFacesAndEnum";
import useDimension from "../../costomHook/useDimention";
import * as UIConstants from "../../UIConstants";

interface StaticImgProps {
  details: any;
  bannerRedirectionUrl: string;
}

enum ButtonSize {
  sm = "small",
  md = "medium",
  lg = "large",
}

enum ButtonVariant {
  primaryFilled = "primary-filled",
  secondary = "secondary",
  primaryLink = "primaryLink",
}

const StaticImageUploader: FC<StaticImgProps> = ({
  details,
  bannerRedirectionUrl,
}) => {
  const dispatch = useDispatch();
  const dimention = useDimension();

  const [bannerUrl, setBannerUrl] = useState("");
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEnaDate] = useState(new Date());
  const [desktopImgUrl1, setDesktopImgUrl1] = useState("");
  const [mobileImgUrl1, setMobileImgUrl1] = useState("");
  const [id, setId] = useState(0);

  // const dummyImgUrl = "https://dummyimage.com/1920x450/000/fff";

  // console.log(details, "details");
  useEffect(() => {
    if (details && Object.keys(details).length > 0) {
      setBannerUrl(details.promotionBannerUrl);
      setStartDate(details.promotionStartDate);
      setEnaDate(details.promotionEndDate);
      setDesktopImgUrl1(
        details.promotionWebBannerImages ? details.promotionWebBannerImages : ""
      );
      setMobileImgUrl1(
        details.promotionMobileBannerImages
          ? details.promotionMobileBannerImages
          : ""
      );
      setId(details.promotionId ? details.promotionId : 0);
    }
  }, []);

  const [isForDesktopImg, setDesktopImgStatus] = useState(false);

  const desktopImgUrl = useSelector(
    (state: RootState) => state.promotions.desktopImagUrl
  );
  const mobileImgUrl = useSelector(
    (state: RootState) => state.promotions.mobileImgUrl
  );
  const desktopImgName = useSelector(
    (state: RootState) => state.promotions.desktopFileName
  );
  const mobileImgName = useSelector(
    (state: RootState) => state.promotions.mobileFileName
  );

  const inputRef = useRef<HTMLInputElement | null>(null);

  const triggerImageUploader = (isforDektop: boolean) => {
    setDesktopImgStatus(isforDektop);
    inputRef.current?.click();
  };

  const validateImage = (file: File) => {
    const validImageTypes = ["image/jpeg", "image/png", "image/jpg,"];
    const maxSize = 2 * 1024 * 1024; // 2MB
    const maxFilenameLength = 100; // Maximum filename length

  if (file.name.length > maxFilenameLength) {
    return `Filename exceeds the maximum length of ${maxFilenameLength} characters.`;
  }

    if (validImageTypes.indexOf(file.type) === -1) {
      return "Invalid file type. Please select a JPEG, PNG, or JPG image.";
    }

    if (file.size > maxSize) {
      return "File size exceeds the limit of 2MB.";
    }

    return null; // Image is valid
  };

  const createUploadFileObj = (event:any) => {
    const selectedFile = event.target.files[0];

    if (selectedFile) {
      const validationError = validateImage(selectedFile);
      if (validationError) {
        dispatch(
          toggleNotificationVisibility({
            isVisible: true,
            status: NotificationType.error,
            message: validationError,
          })
        );
      } else {
        uploadFile(selectedFile);
      }
    }

    event.target.value = null;
  };

  const uploadFile = (files: any) => {
    const formData = new FormData();
    formData.append("file", files);
    formData.append("documentName", updateFileName(files.name));
    dispatch(
      uploadPromotionImages({
        formObj: formData,
        isForDesktop: isForDesktopImg,
        id: id,
      })
    );
  };

  const updateFileName = (fileName: string): string => {
    let updatedName = "";
    if (
      fileName !== null &&
      fileName !== undefined &&
      fileName.trim().length > 0
    ) {
      fileName.trim().split(" ").join("-");
    }
    return updatedName;
  };

  let createStaticImgObj = () => {
    let mobileBannerUrl =
      mobileImgName.length > 0 ? mobileImgName : desktopImgName;
    // console.log(details,"details")
    let requestObj = {};

    requestObj["promotionId"] = details.promotionId;
    requestObj["promotionPage"] = details.promotionPage;
    requestObj["promotionType"] = "STATIC";
    requestObj["promotionPosition"] = "TOP";
    requestObj["promotionStartDate"] = transformGMTToUTC(startDate.toString());
    requestObj["promotionEndDate"] = transformGMTToUTC(endDate.toString());
    requestObj["promotionBannerUrl"] = bannerUrl;
    requestObj["promotionWebBannerImages"] = [desktopImgName];
    requestObj["promotionMobileBannerImages"] = [mobileBannerUrl];
    requestObj["bannerNo"] = details.bannerNo;
    dispatch(updatePromotion(requestObj));
    // dispatch(createPromotion(requestObj))
    // console.log(requestObj);
    
  };

  const updateDateChange = (date: any, name: string) => {
    if (name === "startDate") {
      setStartDate(date);
    } else {
      setEnaDate(date);
    }
  };

  const updateBannerRedirectionUrl = (url: string) => {
    setBannerUrl(url);
  };

  useEffect(() => {
    if (details !== undefined) {
      if (details.promotionMobileBannerImages !== undefined) {
        const Mobparts = details?.promotionMobileBannerImages[0]?.split("/");
        const MobfileName = Mobparts[Mobparts.length - 1];

        // console.log(MobfileName)
        const Webparts = details?.promotionWebBannerImages[0]?.split("/");
        const WebfileName = Webparts[Webparts.length - 1];

        // console.log(WebfileName)
        dispatch(
          setDesktopImgDetails({
            fileName: WebfileName,
            imgUrl: details?.promotionWebBannerImages[0],
          })
        );

        dispatch(
          setMobileImgDetails({
            fileName: MobfileName,
            imgUrl: details?.promotionMobileBannerImages[0],
          })
        );
      }
    }
  }, [details]);

  const desableEnableImageHandler = (id: any) => {
    // console.log(id)
    dispatch(disableEnablePromotionById({
      promotionId:id,
      promotionPage:details?.promotionPage
    }));
  };

  return (
    <StaticBannerSectionWrapper>
      <ActiveInactivewarpper>
        <Button
          title={details?.isActive ? "Disable" : "Enable"}
          btnSize={dimention.width<= UIConstants.mobileWidth ?    ButtonSize.sm : ButtonSize.md}
          btnVariant={ButtonVariant.primaryFilled}
          clicked={() => desableEnableImageHandler(details?.promotionId)}
        />
      </ActiveInactivewarpper>
      <input
        type={"file"}
        ref={inputRef}
        style={{ display: "none" }}
        onChange={(event) => {
          createUploadFileObj(event);
        }}
        accept="image/jpeg, image/png, image/jpg, image/tiff image/gif"
      />
      <DesktopBannerSection>
        <BannerSectionTitle>Desktop Banner (1920x1080) </BannerSectionTitle>

        <AddImageBtn
          onClick={() => {
            triggerImageUploader(true);
          }}
        >
          Add image
        </AddImageBtn>
      </DesktopBannerSection>
      {/* {desktopImgUrl1 && <Img src={desktopImgUrl1} alt={"desktop"} />} */}
      {desktopImgUrl && <Img src={desktopImgUrl} alt={"desktop"} key={desktopImgUrl} />}
      <DesktopBannerSection>
        <BannerSectionTitle>
          Mobile Banner (1440x2960)
          <BannerSectionSubtitle>
            Note: If mobile banner is not added, by default desktop banner will
            be displayed
          </BannerSectionSubtitle>
        </BannerSectionTitle>

        <AddImageBtn
          onClick={() => {
            triggerImageUploader(false);
          }}
        >
          Add image
        </AddImageBtn>
      </DesktopBannerSection>
      {/* {mobileImgUrl1 && <Img src={mobileImgUrl1} alt={"mobile view"} />} */}
      {mobileImgUrl && <Img src={mobileImgUrl} key={mobileImgUrl} alt={"mobile view"} />}
      <StaticFormSection>
        {/* <StaticForm bannerRedirectionUrl={bannerRedirectionUrl} details={details} /> */}
      </StaticFormSection>
      <TestStaticForm
        startDate={startDate}
        endDate={endDate}
        url={bannerUrl}
        onDateChange={updateDateChange}
        onUrlChange={updateBannerRedirectionUrl}
      />
      <Button
        title={"Update"}
        btnSize={dimention.width<= UIConstants.mobileWidth ?    ButtonSize.sm : ButtonSize.md}
        btnVariant={ButtonVariant.primaryFilled}
        clicked={createStaticImgObj}
      >
        Update
      </Button>
    </StaticBannerSectionWrapper>
  );
};

export default StaticImageUploader;
